export type TenantDefaultMargins = {
  readonly targetMarginPercentage: string;
  readonly minimumMarginPercentage: string;
  readonly targetMarginFlatAmount: string;
  readonly minimumMarginFlatAmount: string;
};

export const EmptyTenantDefaultMargins: TenantDefaultMargins = {
  targetMarginFlatAmount: '',
  minimumMarginFlatAmount: '',
  targetMarginPercentage: '',
  minimumMarginPercentage: '',
};
